/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type Reason = 1 | 2 | 3 | 4 | 5 | 7 | 8 | 9;

export const Reason = {
    NUMBER_1: 1 as Reason,
    NUMBER_2: 2 as Reason,
    NUMBER_3: 3 as Reason,
    NUMBER_4: 4 as Reason,
    NUMBER_5: 5 as Reason,
    NUMBER_7: 7 as Reason,
    NUMBER_8: 8 as Reason,
    NUMBER_9: 9 as Reason
};